import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped} from "#/src/definitions/AppDefinitions";
import {useData} from "vike-react/useData";
import {ApiLivestreamData} from "#/src/definitions/ApiDefinitions";
import useFullscreenStatus from "#/src/hooks/use-fullscreen-status";

export function EmbedContent() {
  const pageContext = usePageContext() as AppPageContext;
  const {user} = pageContext;
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  const isFullscreen = useFullscreenStatus();
  function getChatEmbed() {
    const embed = livestreamData.streamer.chatEmbed;
    if(embed.includes("kick")) {
      return embed;
    }
    return embed + (user.lightMode ? "" : "&darkpopout");
  }
  return <section className="twitch h-100" id="live">
    <div className="p-0 h-100">
      <div className="row g-0 h-100">
        <div className="col-xl-9 col-lg-9 col-md-12 h-100">
          <div className="twitch-embed">
            <iframe
              id={"liveEmbed"}
              src={livestreamData.streamer.liveEmbed}
              height={isFullscreen ? "100%" : "740px"}
              width="100%"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            >
            </iframe>
          </div>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-12 h-100">
          <div className="twitch-chat">
            <iframe
              id={"chatEmbed"}
              className="twitch-chat-embed"
              src={getChatEmbed()}
              height={isFullscreen ? "100%" : "740px"}
              sandbox={"allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"}
              width="100%"
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
}